import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { config } from "@fortawesome/fontawesome-svg-core"
import { faFacebook, faInstagram, faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { OutboundLink } from "gatsby-plugin-google-analytics"


// disable the auto CSS insertion
config.autoAddCss = false

const Footer = ({ siteTitle }) => {
  return (
    <>
      <footer className="bg-black w-auto px-4 sm:px-10 pt-10 sm:pt-20 pb-14 sm:pb-14">
        <div className="max-w-theme-max-w mx-auto">
          <div className="my-0 mx-auto flex flex-col sm:flex-row">
            <div id="footer-logo" className="self-center">
              <Link to="/">
                <StaticImage
                  src="../images/abed-group-logo.svg"
                  loading="lazy"
                  height={40}
                  formats={["auto", "webp", "avif"]}
                  alt={siteTitle}
                  className="inline-block"
                />
              </Link>
              {/* <div className='text-xs pt-4'>+1555 555-5555</div>
              <div className='text-xs pt-4'>info@abed.com</div> */}


              {/* <div className="flex flex-col sm:flex-row justify-between">
              <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full sm:w-1/5 section-white-bg">
                <div className="pb-6">
                  <div className="text-lg leading-normal font-light border-t border-black pt-4">Social Media</div>

                  <div>
                    <div className="flex gap-x-3 justify-start items-center text-lg leading-normal font-semibold">
                      <OutboundLink href="https://www.facebook.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                        <FontAwesomeIcon icon={faFacebook} className={`w-6 hover:text-theme-yellow`} />
                      </OutboundLink>

                      <OutboundLink href="https://www.instagram.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                        <FontAwesomeIcon icon={faInstagram} className={`w-6 hover:text-theme-yellow`} />
                      </OutboundLink>

                      <OutboundLink href="https://twitter.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                        <FontAwesomeIcon icon={faTwitter} className={`w-6 hover:text-theme-yellow`} />
                      </OutboundLink>

                      <OutboundLink href="https://www.linkedin.com/company/abed-group/" target="_blank" rel="noreferrer" className="">
                        <FontAwesomeIcon icon={faLinkedin} className={`w-6 hover:text-theme-yellow`} />
                      </OutboundLink>
                    </div>
                  </div>
                </div>

                <div className="pb-6">
                  <div className="text-lg leading-normal font-light border-t border-black pt-4">Phone</div>

                  <div className="text-lg leading-normal font-semibold">
                    <OutboundLink href="tel:+12462656209" target="_blank" rel="noreferrer" className="">
                      +1 (246) 265-6209
                    </OutboundLink>
                  </div>
                </div>

                <div className="pb-6">
                  <div className="text-lg leading-normal font-light border-t border-black pt-4">Email Address</div>

                  <div className="text-lg leading-normal font-semibold">
                    <OutboundLink href="mailto:info@abed.com" target="_blank" rel="noreferrer" className="">
                      info@abed.com
                    </OutboundLink>
                  </div>
                </div>

                <div>
                  <div className="text-lg leading-normal font-light border-t border-black pt-4">Business Address</div>

                  <div className="text-lg leading-normal font-semibold">
                    #8 Hastings Plaza, Hastings, Christ Church, Barbados
                  </div>
                </div>
              </div>



            </div> */}
            </div>



            <ul id="footer-links" className="flex-1 flex flex-col sm:flex-row justify-center mt-6 sm:mt-0">
              {/* <MenuLinksFooter
                activeClassName=""
                linkSizeClass={"text-xl"}
              /> */}
            </ul>

            <div id="footer-icons" className="flex gap-x-3 justify-center items-center mt-6 sm:mt-0">
              <OutboundLink href="https://www.facebook.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                <FontAwesomeIcon icon={faFacebook} className={`w-6 p-p3 hover:text-theme-yellow`} />
              </OutboundLink>

              <OutboundLink href="https://www.instagram.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                <FontAwesomeIcon icon={faInstagram} className={`w-6 p-p3 hover:text-theme-yellow`} />
              </OutboundLink>

              <OutboundLink href="https://twitter.com/theabedgroup/" target="_blank" rel="noreferrer" className="">
                <FontAwesomeIcon icon={faTwitter} className={`w-6 p-p3 hover:text-theme-yellow`} />
              </OutboundLink>

              <OutboundLink href="https://www.linkedin.com/company/abed-group/" target="_blank" rel="noreferrer" className="">
                <FontAwesomeIcon icon={faLinkedin} className={`w-6 p-p3 hover:text-theme-yellow`} />
              </OutboundLink>
            </div>
          </div>

          <div className="mt-12 sm:mx-auto">
            <div id="footer-separator" className="my-0 mx-auto border-b border-white-smoke"></div>
          </div>

          <div className="flex gap-x-6 justify-center flex-wrap sm:flex-nowrap pt-8">
            <div className="text-sm basis-full sm:basis-auto text-center mb-6 sm:mb-0">&copy; {new Date().getFullYear()} Abed Group Inc. All rights reserved.</div>

            <Link to="/privacy-policy" className="text-sm common">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-sm common">Terms of Service</Link>

            {/*
            <Link to="/cookies-settings" className="text-sm common">Cookies Settings</Link>
            <OutboundLink href="https://abed.bamboohr.com/careers" target="_blank" rel="noreferrer" className="text-sm common">Careers</OutboundLink>
            */}
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer